$(window).on('load', function () {
    var surveyBody = $('.survey-slider');
    if (!surveyBody.length) {
        return;
    }
    var isSlickLoaded = (typeof $.fn.slick !== 'undefined');
    if (isSlickLoaded) {
        var answers = [];

        surveyBody = surveyBody.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            centerPadding: '100px',
            infinite: false,
            swipe: false,
            prevArrow: '<span class="slick-prev"><i class="fal fa-chevron-left"></i></span>',
            nextArrow: '<span class="slick-next slick-disabled-custom"><i class="fal fa-chevron-right"></i></span>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    centerPadding: '30px'
                }
            }]
        });

        var isValid;

        $('[data-survey-answer]').on('click', function (event) {
            var answer = $(this).data('survey-answer');
            var currslide = $('[data-slick-index="' + surveyBody.slick('slickCurrentSlide') + '"]');
            currslide.find('[data-survey-picked]').addClass('hide');
            currslide.addClass('valid');
            var thumb = currslide.find('[data-survey-picked="' + answer + '"]');
            thumb.removeClass('hide');
            isValid = true;

            setTimeout(function () {
                surveyBody.slick('slickNext');
            }, 400);

            var id = currslide.data('survey-id');
            answers.push({
                "name": "q" + id,
                "value": answer
            });
        });

        $('[data-survey-finish]').on('click', function () {
            $('.mxm_berufe.survey .survey-action').addClass('no-show');
            surveyBody.addClass('finish');
            $(this).addClass('loading');
            sendResult();
        });

        surveyBody.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var currslide = $('[data-slick-index="' + currentSlide + '"]');
            if (currslide.hasClass('valid')) {
                isValid = true;
                surveyBody.find('.slick-next').removeClass('slick-disabled-custom');
            } else {
                isValid = false;
                surveyBody.find('.slick-next').addClass('slick-disabled-custom');
            }

            if (slick.$slides.length-1 == currentSlide) {
                $('.mxm_berufe.survey .survey-action').addClass('no-show');
            } else {
                $('.mxm_berufe.survey .survey-action').removeClass('no-show');
            }
        });

        function sendResult() {
            $.ajax({
                    type: 'GET',
                    url: $('[data-survey-api]').data('survey-api'),
                    data: $.param(answers)
                })
                .done(function (result) {
                    if (result.length) {
                        window.localStorage.setItem('survey', result);
                        var target = $('[data-survey-target]').data('survey-target');
                        target = target + "?survey=" + result;
                        window.location.href = target;
                    } else {
                        var errorMsg = result.message;
                        $('.survey-error').removeClass('d-none');
                        console.warn(result);
                        return;
                    }
                })
                .fail(function (result) {
                    var errorMsg = "Oops. Something went wrong. Please try again.";
                    $('.survey-error').removeClass('d-none');
                    console.warn(result);
                });
        }
    }
});